<template>
  <div class="animated fadeIn lunch-menu-management-page">
    <div class="card">
      <div class="main-card-body">
        <!-- <div class="lunch-management-breadcrumb">
          <span>Đăng ký cơm trưa</span>
          <i class="fa fa-angle-right"></i>
          <strong>Quản lý danh sách món</strong>
        </div> -->

        <div class="body-header lunch-management-header">
          <div class="lunch-management-header__content">
            <h4 class="card-header-title">QUẢN LÝ DANH SÁCH MÓN</h4>
          </div>
          <button
            type="button"
            class="lunch-outline-button"
            @click="goBackToRegistration"
          >
            <i class="fa fa-arrow-left"></i>
            <span>Quay lại</span>
          </button>
        </div>

        <div v-loading="loading" class="lunch-management-layout">
          <section class="lunch-management-card lunch-management-list-card">
            <div class="lunch-management-toolbar">
              <div class="lunch-filter-list">
                <button
                  v-for="category in categoriesWithAll"
                  :key="category"
                  type="button"
                  class="lunch-filter-button"
                  :class="{ 'lunch-filter-button--active': activeCategory === category }"
                  @click="selectCategory(category)"
                >
                  {{ category }}
                </button>
              </div>

              <el-input
                v-model="searchKeyword"
                clearable
                class="lunch-search-input"
                placeholder="Tìm kiếm món ăn..."
                prefix-icon="el-icon-search"
                @input="handleSearchInput"
              />
            </div>

            <div
              v-if="!foods.length"
              class="lunch-management-empty"
            >
              <strong>Chưa có món ăn nào.</strong>
              <span>Hãy thêm món mới để bắt đầu.</span>
            </div>

            <div
              v-else
              ref="lunchTableWrapper"
              class="lunch-table-wrapper"
              @scroll="hideActionTooltip"
              @wheel="hideActionTooltip"
            >
              <el-table
                :data="pagedFoods"
                border
                class="lunch-menu-table"
                empty-text="Không tìm thấy món ăn phù hợp."
              >
                <el-table-column label="STT" width="60" align="center">
                  <template slot-scope="scope">
                    {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column label="Món ăn" min-width="260">
                  <template slot-scope="scope">
                    <div class="lunch-food-info-cell">
                      <img :src="scope.row.image" :alt="scope.row.name" />
                      <div>
                        <strong>{{ scope.row.name }}</strong>
                        <span>{{ scope.row.description || "Chưa có mô tả" }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Loại món" width="120" align="center">
                  <template slot-scope="scope">
                    <span
                      class="lunch-category-badge"
                      :class="getCategoryClass(scope.row.category)"
                    >
                      {{ scope.row.category }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="Đơn giá" width="120" align="right">
                  <template slot-scope="scope">
                    <strong class="lunch-price-text">
                      {{ formatCurrency(scope.row.price) }}
                    </strong>
                  </template>
                </el-table-column>
                <el-table-column label="Trạng thái" width="140" align="center">
                  <template slot-scope="scope">
                    <span
                      class="lunch-status-badge"
                      :class="scope.row.status === FOOD_STATUS.ACTIVE
                        ? 'lunch-status-badge--active'
                        : 'lunch-status-badge--inactive'"
                    >
                      {{ getStatusText(scope.row.status) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="Thao tác" width="120" align="center">
                  <template slot-scope="scope">
                    <div class="lunch-action-buttons">
                      <el-tooltip
                        effect="dark"
                        content="Chỉnh sửa"
                        placement="left"
                        popper-class="lunch-action-tooltip"
                        :manual="true"
                        :value="activeActionTooltip === getActionTooltipKey(scope.row.id, 'edit')"
                      >
                        <el-button
                          size="mini"
                          plain
                          round
                          type="primary"
                          class="lunch-table-action-button"
                          @mouseenter.native="showActionTooltip(scope.row.id, 'edit')"
                          @mouseleave.native="hideActionTooltip"
                          @focus.native="showActionTooltip(scope.row.id, 'edit')"
                          @blur.native="hideActionTooltip"
                          @click="editFood(scope.row)"
                        >
                          <i class="far fa-edit"></i>
                        </el-button>
                      </el-tooltip>
                      <el-tooltip
                        effect="dark"
                        content="Xóa"
                        placement="left"
                        popper-class="lunch-action-tooltip"
                        :manual="true"
                        :value="activeActionTooltip === getActionTooltipKey(scope.row.id, 'delete')"
                      >
                        <el-button
                          size="mini"
                          plain
                          round
                          type="danger"
                          class="lunch-table-action-button"
                          @mouseenter.native="showActionTooltip(scope.row.id, 'delete')"
                          @mouseleave.native="hideActionTooltip"
                          @focus.native="showActionTooltip(scope.row.id, 'delete')"
                          @blur.native="hideActionTooltip"
                          @click="confirmDeleteFood(scope.row)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="lunch-pagination-row" v-if="foods.length">
              <span>{{ paginationSummary }}</span>
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :current-page="currentPage"
                :total="filteredFoods.length"
                @current-change="handlePageChange"
              />
            </div>
          </section>

          <aside class="lunch-management-card lunch-food-form-card">
            <div class="lunch-form-header">
              <h5>
                <i class="fa" :class="isEditing ? 'fa-pencil' : 'fa-plus'"></i>
                {{ isEditing ? "CHỈNH SỬA MÓN" : "THÊM MÓN MỚI" }}
              </h5>
            </div>

            <el-form label-position="top" class="lunch-food-form">
              <el-form-item
                label="Loại món *"
                :class="{ 'is-error': formErrors.category }"
              >
                <el-select
                  v-model="form.category"
                  placeholder="Chọn loại món"
                  @change="clearFieldError('category')"
                >
                  <el-option
                    v-for="category in categories"
                    :key="category"
                    :label="category"
                    :value="category"
                  />
                </el-select>
                <div v-if="formErrors.category" class="lunch-form-error">
                  {{ formErrors.category }}
                </div>
              </el-form-item>

              <el-form-item
                label="Tên món *"
                :class="{ 'is-error': formErrors.name }"
              >
                <el-input
                  v-model="form.name"
                  maxlength="80"
                  placeholder="Nhập tên món"
                  @input="clearFieldError('name')"
                />
                <div v-if="formErrors.name" class="lunch-form-error">
                  {{ formErrors.name }}
                </div>
              </el-form-item>

              <el-form-item label="Mô tả">
                <el-input
                  v-model="form.description"
                  type="textarea"
                  maxlength="200"
                  :rows="4"
                  resize="none"
                  placeholder="Nhập mô tả món ăn..."
                />
                <div class="lunch-textarea-counter">
                  {{ form.description.length }}/200
                </div>
              </el-form-item>

              <el-form-item
                label="Đơn giá *"
                :class="{ 'is-error': formErrors.price }"
              >
                <el-input
                  v-model="form.price"
                  placeholder="Nhập đơn giá"
                  @input="handlePriceInput"
                >
                  <template slot="suffix">đ</template>
                </el-input>
                <div v-if="formErrors.price" class="lunch-form-error">
                  {{ formErrors.price }}
                </div>
              </el-form-item>

              <el-form-item label="Trạng thái">
                <div class="lunch-status-switch-row">
                  <el-switch
                    v-model="form.active"
                    active-color="#ff985c"
                    inactive-color="#cbd5e1"
                  />
                  <span>{{ form.active ? "Đang áp dụng" : "Ngừng áp dụng" }}</span>
                </div>
              </el-form-item>

              <el-form-item label="Hình ảnh món ăn">
                <div class="lunch-image-picker">
                  <div class="lunch-image-preview">
                    <img :src="formImagePreview" alt="Ảnh món ăn" />
                    <button
                      v-if="form.image"
                      type="button"
                      class="lunch-image-remove"
                      aria-label="Bỏ ảnh đã chọn"
                      title="Bỏ ảnh đã chọn"
                      @click="removeSelectedImage"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="lunch-image-actions">
                    <label class="lunch-outline-button">
                      <i class="fa fa-image"></i>
                      <span>Chọn ảnh</span>
                      <input
                        type="file"
                        accept="image/jpeg,image/png,image/webp"
                        @change="handleImageChange"
                      />
                    </label>
                    <button
                      type="button"
                      class="lunch-text-button"
                      @click="useCategoryImage"
                    >
                      Dùng ảnh mặc định
                    </button>
                  </div>
                </div>
                <div class="lunch-image-hint">
                  Chỉ tải ảnh kích thước không quá 300 x 300px.
                </div>
              </el-form-item>

              <div class="lunch-form-actions">
                <button
                  type="button"
                  class="lunch-secondary-button"
                  @click="resetForm"
                >
                  Hủy
                </button>
                <button
                  type="button"
                  class="lunch-primary-button"
                  @click="saveFood"
                >
                  {{ isEditing ? "Lưu thay đổi" : "Lưu món ăn" }}
                </button>
              </div>
            </el-form>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtensionService from "@/service/ExtensionService";
import {
  FOOD_IMAGE_DIMENSION_ERROR,
  getFoodImageUrl,
  prepareFoodImage
} from "./lunchFoodImage";
import {
  LUNCH_FOOD_STATUS,
  createLunchFood,
  deleteLunchFood,
  getLunchFoodCategories,
  loadLunchFoods,
  lunchMenuState,
  updateLunchFood
} from "./lunchMenuStore";

const ALL_CATEGORY = "Tất cả";

export default {
  name: "LunchMenuManagement",
  data() {
    return {
      FOOD_STATUS: LUNCH_FOOD_STATUS,
      activeCategory: ALL_CATEGORY,
      searchKeyword: "",
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editingFoodId: null,
      activeActionTooltip: null,
      tableScrollElement: null,
      imageUploadVersion: 0,
      formErrors: {},
      form: this.getDefaultForm()
    };
  },
  computed: {
    foods() {
      return lunchMenuState.foods;
    },
    categories() {
      return getLunchFoodCategories();
    },
    categoriesWithAll() {
      return [ALL_CATEGORY, ...this.categories];
    },
    filteredFoods() {
      const keyword = this.searchKeyword.trim().toLowerCase();
      return this.foods.filter((food) => {
        const matchesCategory =
          this.activeCategory === ALL_CATEGORY || food.category === this.activeCategory;
        const matchesKeyword =
          !keyword ||
          food.name.toLowerCase().includes(keyword) ||
          (food.description || "").toLowerCase().includes(keyword);
        return matchesCategory && matchesKeyword;
      });
    },
    pagedFoods() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredFoods.slice(start, start + this.pageSize);
    },
    paginationSummary() {
      if (!this.filteredFoods.length) return "Hiển thị 0 trong 0 món ăn";
      const start = (this.currentPage - 1) * this.pageSize + 1;
      const end = Math.min(this.currentPage * this.pageSize, this.filteredFoods.length);
      return `Hiển thị ${start} - ${end} trong ${this.filteredFoods.length} món ăn`;
    },
    isEditing() {
      return Boolean(this.editingFoodId);
    },
    formImagePreview() {
      return getFoodImageUrl(this.form.image, this.form.category || this.categories[0]);
    }
  },
  watch: {
    filteredFoods() {
      const maxPage = Math.max(1, Math.ceil(this.filteredFoods.length / this.pageSize));
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage;
      }
      this.hideActionTooltip();
      this.$nextTick(this.bindTableScrollTooltipCleanup);
    }
  },
  mounted() {
    this.loadFoods();
    this.$nextTick(this.bindTableScrollTooltipCleanup);
  },
  beforeDestroy() {
    this.imageUploadVersion += 1;
    this.unbindTableScrollTooltipCleanup();
    this.hideActionTooltip();
  },
  methods: {
    getDefaultForm() {
      return {
        category: "",
        name: "",
        description: "",
        price: "",
        active: true,
        image: ""
      };
    },
    goBackToRegistration() {
      this.hideActionTooltip();
      this.$router.push({ path: "/admin/lunch-registration" }).catch(() => {});
    },
    getActionTooltipKey(foodId, action) {
      return `${foodId}-${action}`;
    },
    showActionTooltip(foodId, action) {
      this.hideBootstrapPopover();
      this.activeActionTooltip = this.getActionTooltipKey(foodId, action);
    },
    hideActionTooltip() {
      this.activeActionTooltip = null;
      this.hideBootstrapPopover();
    },
    hideBootstrapPopover() {
      if (this.$root && this.$root.$emit) {
        this.$root.$emit("bv::hide::popover");
      }
    },
    bindTableScrollTooltipCleanup() {
      this.unbindTableScrollTooltipCleanup();
      const wrapper = this.$refs.lunchTableWrapper;
      if (!wrapper) return;
      this.tableScrollElement = wrapper.querySelector(".el-table__body-wrapper");
      if (this.tableScrollElement) {
        this.tableScrollElement.addEventListener("scroll", this.hideActionTooltip, {
          passive: true
        });
      }
    },
    unbindTableScrollTooltipCleanup() {
      if (!this.tableScrollElement) return;
      this.tableScrollElement.removeEventListener("scroll", this.hideActionTooltip);
      this.tableScrollElement = null;
    },
    handleSearchInput() {
      this.hideActionTooltip();
      this.currentPage = 1;
    },
    handlePageChange(page) {
      this.hideActionTooltip();
      this.currentPage = page;
    },
    selectCategory(category) {
      this.hideActionTooltip();
      this.activeCategory = category;
      this.currentPage = 1;
    },
    formatCurrency(value) {
      return `${Number(value || 0).toLocaleString("vi-VN")} đ`;
    },
    getStatusText(status) {
      return status === LUNCH_FOOD_STATUS.ACTIVE
        ? "Đang áp dụng"
        : "Ngừng áp dụng";
    },
    getCategoryClass(category) {
      return {
        "Món mặn": "lunch-category-badge--main",
        Rau: "lunch-category-badge--vegetable",
        Canh: "lunch-category-badge--soup",
        "Tráng miệng": "lunch-category-badge--dessert"
      }[category] || "lunch-category-badge--default";
    },
    async loadFoods() {
      this.loading = true;
      try {
        await loadLunchFoods();
      } catch (error) {
        this.showErrorMessage(this.getApiErrorMessage(error, "Không tải được danh sách món ăn."));
      } finally {
        this.loading = false;
      }
    },
    clearFieldError(field) {
      if (!this.formErrors[field]) return;
      this.$delete(this.formErrors, field);
    },
    handlePriceInput(value) {
      this.form.price = String(value || "").replace(/[^\d]/g, "");
      this.clearFieldError("price");
    },
    validateForm() {
      const errors = {};
      const name = this.form.name.trim();
      const price = Number(this.form.price);

      if (!this.form.category) {
        errors.category = "Vui lòng chọn loại món.";
      }
      if (!name) {
        errors.name = "Vui lòng nhập tên món.";
      } else if (name.length > 80) {
        errors.name = "Tên món không được vượt quá 80 ký tự.";
      }
      if (!this.form.price || !Number.isFinite(price) || price <= 0) {
        errors.price = "Vui lòng nhập đơn giá lớn hơn 0.";
      }

      this.formErrors = errors;
      return Object.keys(errors).length === 0;
    },
    buildFoodPayload() {
      return {
        category: this.form.category,
        name: this.form.name.trim(),
        description: this.form.description.trim(),
        price: Number(this.form.price),
        status: this.form.active
          ? LUNCH_FOOD_STATUS.ACTIVE
          : LUNCH_FOOD_STATUS.INACTIVE,
        image: this.form.image || null
      };
    },
    async saveFood() {
      this.hideActionTooltip();
      if (!this.validateForm()) return;
      try {
        if (this.isEditing) {
          await updateLunchFood(this.editingFoodId, this.buildFoodPayload());
          this.showSuccessMessage("Cập nhật món ăn thành công");
        } else {
          await createLunchFood(this.buildFoodPayload());
          this.showSuccessMessage("Thêm món ăn thành công");
        }
        this.resetForm();
      } catch (error) {
        this.showErrorMessage(this.getApiErrorMessage(error, "Không lưu được món ăn."));
      }
    },
    editFood(food) {
      this.hideActionTooltip();
      this.imageUploadVersion += 1;
      this.editingFoodId = food.id;
      this.formErrors = {};
      this.form = {
        category: food.category,
        name: food.name,
        description: food.description || "",
        price: String(food.price || ""),
        active: food.status === LUNCH_FOOD_STATUS.ACTIVE,
        image: food.imageId || ""
      };
    },
    confirmDeleteFood(food) {
      this.hideActionTooltip();
      const removeFood = () => {
        deleteLunchFood(food.id)
          .then(() => {
            if (this.editingFoodId === food.id) {
              this.resetForm();
            }
            this.showSuccessMessage("Xóa món ăn thành công");
          })
          .catch((error) => {
            this.showErrorMessage(this.getApiErrorMessage(error, "Không xóa được món ăn."));
          });
      };

      if (this.$confirm) {
        this.$confirm(
          `Bạn có chắc chắn muốn xóa "${food.name}" khỏi danh sách món?`,
          "Xóa món ăn?",
          {
            confirmButtonText: "Xóa",
            cancelButtonText: "Hủy",
            type: "warning",
            confirmButtonClass: "lunch-delete-confirm-button"
          }
        )
          .then(removeFood)
          .catch(() => {});
        return;
      }

      if (window.confirm(`Bạn có chắc chắn muốn xóa "${food.name}" khỏi danh sách món?`)) {
        removeFood();
      }
    },
    resetForm() {
      this.hideActionTooltip();
      this.imageUploadVersion += 1;
      this.editingFoodId = null;
      this.formErrors = {};
      this.form = this.getDefaultForm();
    },
    useCategoryImage() {
      if (!this.form.category) {
        this.$set(this.formErrors, "category", "Vui lòng chọn loại món trước.");
        return;
      }
      this.imageUploadVersion += 1;
      this.form.image = "";
    },
    removeSelectedImage() {
      this.imageUploadVersion += 1;
      this.form.image = "";
    },
    async handleImageChange(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;
      const uploadVersion = ++this.imageUploadVersion;
      try {
        const preparedFile = await prepareFoodImage(file);
        const response = await ExtensionService.upload(preparedFile, "LunchFood");
        if (uploadVersion === this.imageUploadVersion && response && response.result) {
          this.form.image = response.result;
        }
      } catch (error) {
        const message = error && error.message ? error.message : "Không tải được ảnh món ăn.";
        if (error && error.code === FOOD_IMAGE_DIMENSION_ERROR) {
          this.showWarningMessage(message);
        } else {
          this.showErrorMessage(message);
        }
      }
    },
    showSuccessMessage(message) {
      if (this.$message) {
        this.$message.success(message);
      }
    },
    showErrorMessage(message) {
      if (this.$message) {
        this.$message.error(message);
      }
    },
    showWarningMessage(message) {
      if (this.$message) {
        this.$message({
          type: "warning",
          message,
          customClass: "lunch-image-dimension-message"
        });
      }
    },
    getApiErrorMessage(error, fallback) {
      return (error && error.result && error.result.message) || (error && error.message) || fallback;
    }
  }
};
</script>

<style lang="scss" scoped>
.lunch-menu-management-page {
  box-sizing: border-box;
  height: auto;
  min-height: 100%;
  min-width: 0;
  padding-right: 10px;
  padding-top: 20px;
  font-family: UTM Avo;
  font-size: 14px;

  > .card {
    height: auto;
    min-height: 100%;
    margin-bottom: 0;
  }

  .main-card-body {
    padding-right: 10px;
    display: flex;
    min-height: 0 !important;
    height: auto;
    flex-direction: column;
  }
}

.lunch-management-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 13px;

  strong {
    color: #111827;
    font-weight: 500;
  }
}

.lunch-management-header {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: clamp(10px, 1vw, 16px);
  margin-bottom: clamp(10px, 1vw, 16px);
  padding-right: 0;
  padding-left: 0;
}

.lunch-management-header__content {
  min-width: 0;
}

.lunch-management-header__content .card-header-title {
  font-size: 20px;

}

.lunch-management-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.35;
}

.lunch-primary-button,
.lunch-secondary-button,
.lunch-outline-button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  font-family: UTM Avo;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  padding: 8px 13px;
  transition: background-color 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
  white-space: nowrap;

  &:active {
    transform: translateY(1px);
  }
}

.lunch-primary-button {
  border: 1px solid var(--orange);
  background: var(--orange);
  color: #fff;

  i {
    color: #fff;
  }

  &:hover,
  &:focus {
    border-color: #f58245;
    background: #f58245;
    color: #fff;
    outline: none;
  }
}

.lunch-secondary-button,
.lunch-outline-button {
  border: 1px solid var(--orange);
  background: #fff;
  color: var(--orange);

  i {
    color: var(--orange);
  }

  &:hover,
  &:focus {
    background: var(--orange_background);
    color: var(--orange);
    outline: none;
  }
}

.lunch-management-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 24vw);
  gap: clamp(10px, 1.1vw, 18px);
  align-items: stretch;
  min-height: 0;
  min-width: 0;
  overflow: visible;
}

.lunch-management-card {
  min-height: 0;
  min-width: 0;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 41, 55, 0.06);
  padding: clamp(12px, 1vw, 18px);
}

.lunch-management-list-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lunch-food-form-card {
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.lunch-management-toolbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(8px, 1vw, 12px);
  margin-bottom: clamp(10px, 1vw, 14px);
}

.lunch-filter-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.lunch-filter-button {
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #fff;
  color: #4b5563;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  min-height: 32px;
  padding: 6px 12px;
  transition: all 0.16s ease;

  &:hover {
    border-color: var(--orange);
    color: var(--orange);
  }
}

.lunch-filter-button--active {
  border-color: var(--orange);
  background: var(--orange_background);
  color: var(--orange);
}

.lunch-search-input {
  max-width: 280px;
  flex: 0 1 clamp(180px, 24vw, 280px);
}

.lunch-table-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.lunch-menu-table {
  width: max(100%, 860px) !important;
  min-width: 860px;
  max-width: none;
}

.lunch-table-wrapper ::v-deep .el-table__body-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}

.lunch-table-wrapper ::v-deep .el-table__header,
.lunch-table-wrapper ::v-deep .el-table__body {
  width: 100% !important;
  min-width: 860px;
}

.lunch-food-info-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;

  img {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    border-radius: 8px;
    object-fit: cover;
  }

  div {
    display: grid;
    gap: 4px;
    min-width: 0;
  }

  strong {
    color: #111827;
    font-size: 14px;
    font-weight: 500;
  }

  span {
    overflow: hidden;
    color: #6b7280;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.lunch-category-badge,
.lunch-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  padding: 6px 10px;
  white-space: nowrap;
}

.lunch-category-badge--main {
  background: #fff1e8;
  color: #ea7a30;
}

.lunch-category-badge--vegetable {
  background: #e8f7ee;
  color: #17834d;
}

.lunch-category-badge--soup {
  background: #eff6ff;
  color: #2563eb;
}

.lunch-category-badge--dessert {
  background: #fff7d6;
  color: #a16207;
}

.lunch-category-badge--default {
  background: #f3f4f6;
  color: #6b7280;
}

.lunch-status-badge--active {
  background: #e8f7ee;
  color: #17834d;
}

.lunch-status-badge--inactive {
  background: #f3f4f6;
  color: #6b7280;
}

.lunch-price-text {
  color: #111827;
  font-size: 13px;
  font-weight: 500;
}

.lunch-action-buttons {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.lunch-action-buttons ::v-deep .lunch-table-action-button.el-button--mini {
  min-width: 30px;
  min-height: 28px;
  padding: 6px 9px;

  i {
    font-size: 13px;
  }
}

.lunch-pagination-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: clamp(8px, 0.8vw, 12px);
  color: #6b7280;
  font-size: 13px;
}

.lunch-management-empty {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  gap: 6px;
  border: 1px dashed #d8dde6;
  border-radius: 8px;
  color: #6b7280;
  padding: 28px;
  text-align: center;

  strong {
    color: #111827;
    font-weight: 500;
  }
}

.lunch-form-header {
  flex: 0 0 auto;
  margin-bottom: clamp(8px, 0.8vw, 14px);

  h5 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    color: #111827;
    font-size: 18px;
    font-weight: 500;
  }

  i {
    color: var(--orange);
    font-size: 16px;
  }
}

.lunch-food-form {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;

  ::v-deep .el-form-item {
    margin-bottom: clamp(8px, 1vh, 12px);
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 5px;
    line-height: 24px;
  }

  ::v-deep .el-select,
  ::v-deep .el-input,
  ::v-deep .el-textarea {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    height: clamp(36px, 4.7vh, 40px);
    line-height: clamp(36px, 4.7vh, 40px);
  }

  ::v-deep .el-textarea__inner {
    height: clamp(72px, 10vh, 96px);
    min-height: 72px !important;
  }
}

.lunch-form-error {
  margin-top: 5px;
  color: #dc2626;
  font-size: 12px;
  line-height: 1.3;
}

.lunch-textarea-counter {
  margin-top: 5px;
  color: #9ca3af;
  font-size: 12px;
  text-align: right;
}

.lunch-status-switch-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #374151;
  font-size: 13px;

  ::v-deep .el-switch {
    display: inline-flex;
    height: 24px;
    align-items: center;
  }

  ::v-deep .el-switch__core {
    width: 48px !important;
    height: 24px;
    border: none;
    border-radius: 999px;
  }

  ::v-deep .el-switch__core::after {
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    margin-left: 0;
  }

  ::v-deep .el-switch.is-checked .el-switch__core::after {
    left: calc(100% - 21px);
    margin-left: 0;
  }
}

.lunch-image-picker {
  display: grid;
  grid-template-columns: 60px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  margin-top: 4px;
}

.lunch-image-preview {
  position: relative;
  width: 60px;
  height: 60px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    border: 1px solid #edf0f5;
    border-radius: 8px;
    object-fit: cover;
  }
}

.lunch-image-remove {
  position: absolute;
  top: -5px;
  right: -5px;
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(17, 24, 39, 0.72);
  color: #fff;
  cursor: pointer;
  font-size: 11px;
  opacity: 0;
  padding: 0;
  pointer-events: none;
  transition: opacity 0.16s ease, background-color 0.16s ease;

  &:hover,
  &:focus {
    background: #ff6b6b;
    outline: none;
  }
}

.lunch-image-preview:hover .lunch-image-remove,
.lunch-image-preview:focus-within .lunch-image-remove {
  opacity: 1;
  pointer-events: auto;
}

.lunch-image-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.lunch-image-hint {
  margin-top: 6px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.4;
}

.lunch-outline-button {
  min-height: 34px;
  padding: 7px 11px;

  input {
    display: none;
  }
}

.lunch-text-button {
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  font-size: 13px;
  padding: 0;

  &:hover {
    color: var(--orange);
  }
}

.lunch-form-actions {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #edf0f5;
  margin-top: auto;
  padding-top: clamp(10px, 1.2vh, 14px);
}

@media (max-width: 1350px) {
  .lunch-management-layout {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 330px);
  }
}

@media (max-width: 1099px) {
  .lunch-menu-management-page {
    height: auto;
    padding-right: 0;
    min-height: 100%;
  }

  .lunch-management-layout {
    grid-template-columns: minmax(0, 1fr);
    overflow: visible;
  }

  .lunch-food-form-card {
    overflow: visible;
  }
}

@media (max-height: 800px) and (min-width: 1100px) {
  .lunch-management-header {
    margin-bottom: 10px;
  }

  .lunch-management-subtitle {
    font-size: 13px;
  }

  .lunch-primary-button,
  .lunch-secondary-button,
  .lunch-outline-button {
    min-height: 36px;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .lunch-management-card {
    padding: 12px;
  }

  .lunch-food-form ::v-deep .el-form-item {
    margin-bottom: 8px;
  }

  .lunch-food-form ::v-deep .el-form-item__label {
    padding-bottom: 4px;
  }

  .lunch-food-form ::v-deep .el-textarea__inner {
    height: 72px;
  }

  .lunch-form-header {
    margin-bottom: 8px;
  }

  .lunch-image-picker {
    grid-template-columns: 56px minmax(0, 1fr);
  }

  .lunch-image-preview {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 767px) {
  .lunch-management-header,
  .lunch-management-toolbar,
  .lunch-pagination-row {
    align-items: stretch;
    flex-direction: column;
  }

  .lunch-primary-button,
  .lunch-secondary-button {
    width: 100%;
  }

  .lunch-search-input {
    max-width: none;
    flex-basis: auto;
    width: 100%;
  }

  .lunch-management-card {
    padding: 14px;
  }

  .lunch-form-actions {
    flex-direction: column-reverse;
  }
}

@media (max-width: 420px) {
  .lunch-image-picker {
    grid-template-columns: 1fr;
  }

  .lunch-image-preview {
    width: 100%;
    height: 120px;
  }
}
</style>

<style lang="scss">
.el-tooltip__popper.lunch-action-tooltip {
  border: 1px solid #d8dde6;
  background: #fff;
  color: #111827;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.14);
}

.el-tooltip__popper.lunch-action-tooltip[x-placement^="left"] .popper__arrow {
  border-left-color: #d8dde6;
}

.el-tooltip__popper.lunch-action-tooltip[x-placement^="left"] .popper__arrow::after {
  border-left-color: #fff;
}

.el-message.lunch-image-dimension-message {
  border-color: #fde68a;
  background-color: #fffbeb !important;
  box-shadow: 0 4px 14px rgba(146, 64, 14, 0.1);
}

.el-message.lunch-image-dimension-message .el-message__content {
  color: #92400e !important;
}

.el-message.lunch-image-dimension-message .el-message__icon,
.el-message.lunch-image-dimension-message .el-message__closeBtn {
  color: #d97706 !important;
}
</style>
